var map = {
	"./Green-VeryLow.png": 822,
	"./Green-VeryLow.svg": 1733,
	"./Red-Excessive.png": 818,
	"./Red-Excessive.svg": 1734,
	"./RedYellow-Significant.png": 819,
	"./RedYellow-Significant.svg": 1735,
	"./White-Unknown.png": 588,
	"./White-Unknown.svg": 1736,
	"./Yellow-Moderate.png": 820,
	"./Yellow-Moderate.svg": 1737,
	"./YellowGreen-Low.png": 821,
	"./YellowGreen-Low.svg": 1738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1732;